import { useEffect } from "react";
import { ssoApi } from "../../api/sso";
import FullScreenLoader from "../../components/fullScreenLoader/FullScreenLoader";
import { refreshCookieExists } from "../../utilities/cookies";
import { getAuthSettings } from "../settings";

const postLogoutRedirectParam = "post_logout_redirect_uri";

interface Props {
  redirectUri: string;
}

const Logout = ({ redirectUri }: Props) => {
  useEffect(() => {
    if (refreshCookieExists()) {
      const navigateToErrorPage = () => (window.location.href = "/error");

      const { userFlowSignIn, cookieTarget } = getAuthSettings();

      ssoApi
        .logout({ userFlow: userFlowSignIn, cookieTarget })
        .then((response) => {
          if (response.success) {
            try {
              const url = new URL(response.data.redirectToLogoutUrl);
              url.searchParams.append(postLogoutRedirectParam, redirectUri);
              window.location.href = url.toString();
            } catch {
              navigateToErrorPage();
            }
          } else {
            navigateToErrorPage();
          }
        })
        .catch(navigateToErrorPage);
    }
  }, [redirectUri]);

  return <FullScreenLoader title="Please wait." subtitle="We're logging you out..." />;
};

export default Logout;
